/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { ApplyPanelDataActionsNames } from './panel-data-action-name';
import { SelectedPanelDataItem } from '../../models/selected-panel-data-item';

export const ValidatePanelCircuitData = createAction(ApplyPanelDataActionsNames.ValidatePanelCircuitData());
export const ValidatePanelCircuitDataSuccess = createAction(
  ApplyPanelDataActionsNames.ValidatePanelCircuitDataSuccess(),
  props<{ response: any }>()
);

export const ChangeApplyPanelDialogSize = createAction(
  ApplyPanelDataActionsNames.ChangeApplyPanelDialogSize(),
  props<{ height: number }>()
);

export const ChangeApplyPanelDialogSizeSuccess = createAction(
  ApplyPanelDataActionsNames.ChangeApplyPanelDialogSizeSuccess(),
  props<{ response: string }>()
);

export const ApplyPanelData = createAction(
  ApplyPanelDataActionsNames.ApplyPanelDataClick(),
  props<{ item:SelectedPanelDataItem }>()
);

export const ApplyPanelDataSuccess = createAction(
  ApplyPanelDataActionsNames.ApplyPanelDataClickSuccess(),
  props<{ response: any }>()
);
